import { Pipe, PipeTransform } from '@angular/core';
import { format, isValid, parseISO } from 'date-fns';
import { isString } from 'lodash-es';

type DateFnsInputDate = string | number | Date | null | undefined;

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(date: DateFnsInputDate, dateFormat = 'MM/dd/yy HH:mm', inputDateFormat?: 'ISO' | 'string'): string {
    if (!date) {
      return '';
    }

    const dateTime = isString(date) && !date.includes('T') ? `${date}T00:00` : date;
    const dateObj = inputDateFormat === 'ISO' && isString(date) ? parseISO(date) : new Date(dateTime);

    // An unparseable value is an Invalid Date, which date-fns format() rejects with "RangeError: Invalid time value"
    return isValid(dateObj) ? format(dateObj, dateFormat) : '';
  }
}
